export default __webpack_public_path__ + "imgs/e5f5b1a0fcdca0e11add3dac5f533327.png";